import { Component } from '@angular/core';
import { LoaderService } from './core/services/loader.service';
import { SiderService } from './core/services/sider.service';
import { TranslationService } from './core/services/translation.service';
import { ImageService } from './core/services/image.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'blinker-admin';

  constructor(
    private loaderService: LoaderService,
    private siderService: SiderService,
    private translationService: TranslationService,
    private imageService: ImageService
  ) { }

  ngOnInit() {
    this.loaderService.init()
    this.siderService.init()
    this.translationService.init()
    this.imageService.init()
  }

}
